const employee_id=localStorage.getItem("employee_id")
const school_code=localStorage.getItem("school_code")

export {employee_id,school_code}